/*
 * @author Pierre Comble
 * Browser detection patch
 */
jQuery.browser = {};
jQuery.browser.mozilla = /mozilla/.test(navigator.userAgent.toLowerCase()) && !/webkit/.test(navigator.userAgent.toLowerCase());
jQuery.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
jQuery.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
jQuery.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());

/**
 * @author Pierre Comble
 * console.log patch pour IE7 et IE8
 */
var alertFallback = false;
if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = {};
    if (alertFallback) {
        console.log = function (msg) {
            alert(msg);
        };
    } else {
        console.log = function () {
        };
    }
}

//-----------------------------------------------------------
// Configuration
//-----------------------------------------------------------
$.cookie.json = true;

/**
 *
 * @param dateTime
 * @returns {Date}
 */
var sqlDatetimeToDate = function (dateTime) {
    var t = dateTime.split(/[- :]/);
    return new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]); // Apply each element to the Date function
};

/**
 *
 * @param url
 * @param withVersion bool add version if true
 * @returns {*}
 */
var getAsset = function (url, withVersion) {
    if (url.trim() == '') {
        return '';
    }
    var pat = /^(https?:)?\/\//i;
    if (!pat.test(url)) {
        url = url.replace(/^\//g, '');
        url = urlbaseAsset + url;
    }

    if (typeof withVersion != 'undefined' && withVersion) {
        var pat2 = /\?./i;
        if (pat2.test(url)) {
            url = url + '&' + assetsVersion;
        } else {
            url = url + '?' + assetsVersion;
        }
    }
    return url;
};

/**
 *
 * @param url
 * @returns {*}
 */
var getUrl = function (url) {
    var pat = /^(https?:)?\/\//i;
    if (!pat.test(url)) {
        url = url.replace(/^\//g, '');
        url = urlbaseuserWithRelativePath + url;
    }
    return url;
};

/**
 *
 * @param url
 * @returns {*}
 */
var getUrlLegacy = function (url) {
    var pat = /^https?:\/\//i;
    if (!pat.test(url)) {
        url = url.replace(/^\//g, '');
        url = urlLegacy + url;
    }
    return url;
};

/**
 *
 * @param type
 * @returns {*}
 */
var getImageDefaultByType = function (type) {
    switch (type) {
        case 'place':
            return getAsset('bundles/digitickcms/images/places/defaut.png');
            break;
        case 'artist':
            return getAsset('bundles/digitickcms/images/artists/defaut.png');
            break;
        case 'regroupement':
        case 'event':
        case 'show':
        default :
            return getAsset('bundles/digitickcms/images/events/defaut.png');
            break;
    }
    ;
};

(function ($) {
    'use strict';
    $.fn.waiting = function (action) {
        return this.each(function () {
            var link = $(this);
            if (action === "on") {
                link.addClass("reload");
            }

            if (action === "off") {
                link.removeClass("reload");
            }
        });
    };

    $.fn.hasScrollBar = function () {
        return this.get(0).scrollHeight > this.height();
    }


}(jQuery));

// GEOLOCALISATION
var GEOLOCALISATION = null;
(function ($, GEOLOCALISATION) {
    'use strict';
    $(document).ready(function ($) {
        try {
            GEOLOCALISATION = $.cookie('next-geolocation');
        } catch (e) {
            GEOLOCALISATION
        }
    });
}(jQuery, GEOLOCALISATION));

(function ($) {
    'use strict';
    $(document).ready(function () {

        $('body').on('click', '.dropdown-select .dropdown-menu li', function () {
            var $target = $(this);

            $target.closest('.dropdown').find('.dropdown-toggle [data-bind="label"]')
                .text($target.text())
                .end()
                .children('.dropdown-toggle').dropdown('toggle');

            return false;
        });

        $('body').on('mousewheel', '.mousewheel-prevent-default', function (e) {
            var event = e.originalEvent,
                d = event.wheelDelta || -event.detail;

            this.scrollTop += ( d < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        $('[data-toogle-hover-class]').each(function () {
            var _this = $(this);
            var toogleHoverClass = $(this).data('toogle-hover-class');
            _this.find('>li.active-default').addClass(toogleHoverClass);

            $(this).find('>li').hover(
                function () {
                    _this.find('>li').removeClass(toogleHoverClass);
                    $(this).addClass(toogleHoverClass);
                }, function () {
                    _this.find('>li').removeClass(toogleHoverClass);
                    _this.find('>li.active-default').addClass(toogleHoverClass);
                }
            );
        });

    });
}( jQuery ));
(function ($) {
    'use strict';
    $(document).ready(function ($) {
        $('[data-toggle="tooltip"]').tooltip();
    });
})(jQuery);

(function ($) {
   $(document).ready(function () {
       var tradKlingon = function () {
           $('body').toggleClass('klingon');
       }
       //Up, Up, Down, Down, Left, Right, Left, Right, B, A
       var n = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
           r = 0;

       $(document).keydown(function (e) {
           if (e.keyCode === n[r++]) {
               if (r === n.length) {
                   tradKlingon();
                   r = 0;
                   return !1
               }
           } else r = 0
       });
   });
}(jQuery));




